import React, { Component } from 'react'
import BaseLayout from 'containers/BaseLayout'
import HeaderTitle from 'components/HeaderTitle'

import {
  Columns, Column,
  Menu, MenuLabel, MenuList, MenuLink
} from 'bloomer'

import { NavLink, Switch, Route, Redirect } from 'react-router-dom'

import Profile from './Profile'
import Account from './Account'

export default class SettingsPage extends Component {
  render() {
    const { match } = this.props

    return (
      <BaseLayout title={() => (
        <HeaderTitle>Configurações</HeaderTitle>
      )}>

        <Columns>
          <Column isSize={3}>
            <Menu>
              <MenuLabel>CONFIGURAÇÕES PESSOAIS</MenuLabel>
              <MenuList>
                <li><MenuLink render={(props) => <NavLink activeClassName="is-active" to={`${match.url}/profile`} {...props}>Perfil</NavLink>}/></li>
                <li><MenuLink render={(props) => <NavLink activeClassName="is-active" to={`${match.url}/account`} {...props}>Conta</NavLink>}/></li>
              </MenuList>
              <MenuLabel>ADMINISTRAÇÃO</MenuLabel>
              <MenuList>
                <li><MenuLink render={(props) => <NavLink activeClassName="is-active" to={`${match.url}/houses`} {...props}>Casas</NavLink>}/></li>
                <li><MenuLink render={(props) => <NavLink activeClassName="is-active" to={`${match.url}/modules`} {...props}>Módulos</NavLink>}/></li>
              </MenuList>
            </Menu>
          </Column>

          <Column isSize={9}>
            <Switch>
              <Route path={`${match.url}/profile`} component={Profile} />
              <Route path={`${match.url}/account`} component={Account} />
              <Redirect to={`${match.url}/profile`} />
            </Switch>
          </Column>
        </Columns>

      </BaseLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SettingsPage/index.js